import { CommonModule } from "@angular/common";
import { ComponentFactoryResolver, CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { CoreModule } from "@obg/ngx.core";
import { CoreContentModule } from "@obg/ngx.core.content";
import { GlobalModule } from "@obg/ngx.global";
import { ComponentFactoryService, CoreUiModule } from "@obg/ngx.ui.core";

import { BankIdAuthContainer } from "./bank-id-auth/bank-id-auth.container";

const DIRECTIVES: any[] = [BankIdAuthContainer];
const ENTRY_COMPONENTS: any[] = [BankIdAuthContainer];

@NgModule({
	imports: [CommonModule, RouterModule, TranslateModule, GlobalModule, CoreModule, CoreContentModule, CoreUiModule],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class BankIdModule {
	constructor(componentFactoryService: ComponentFactoryService, resolver: ComponentFactoryResolver) {
		componentFactoryService.registerLazyLoadedResolver(resolver, ...ENTRY_COMPONENTS);
	}
}
